const menu = {
  key: "alertDefinitions",
  route: "/system/alerts",
  label: "sidebar.alerts",
  permission: "alerts.read",
  icon: "faBell",
  group: "system",
  order: 50
};

export default menu;
